export default __webpack_public_path__ + "static/media/cl-7.4984b5df.png";